module.exports = __webpack_public_path__ + "img/menuIcon20.c0970e63.png";